<template>
  <u-animate-container>
    <div v-if="isLoading">
      <v-img
        src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606300158063.png"
      ></v-img>
    </div>
    <div v-else>
      <front-header />
      <div class="container-section auth-form">
        <div class="max-container">
          <v-row>
            <v-col>
              <u-animate name="fadeInLeft" class="wow" delay="0.6s">
                <div class="login-left-content">
                  <h1>
                    Welcome to
                    <strong>Grow Pharma</strong>
                  </h1>
                  <p>Sign up and let’s get started!</p>
                  <div class="image-box">
                    <img
                      src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606300052247.png"
                      alt
                    />
                  </div>
                </div>
              </u-animate>
            </v-col>
            <v-col>
              <u-animate name="fadeInRight" class="d-flex wow" delay="0.6s">
                <div class="login-right-block">
                  <div class="login-box">
                    <ul class="login-nav mb-12">
                      <li>
                        <router-link :to="{ path: '/login' }"
                          >LOG IN</router-link
                        >
                      </li>
                      <li class="active">
                        <router-link :to="{ path: '/signup' }"
                          >Sign up</router-link
                        >
                      </li>
                    </ul>
                    <v-stepper
                      :value="stepper"
                      flat
                      class="signup-stepper mb-5"
                    >
                      <v-stepper-header>
                        <v-stepper-step
                          step="1"
                          :complete="stepper > 1"
                          :class="
                            stepper > 1
                              ? 'signup-step  pr-0'
                              : 'signup-step hide-step-content  pr-0'
                          "
                        >
                        </v-stepper-step>
                        <v-divider class="text-red"></v-divider>
                        <v-stepper-step
                          step="2"
                          :complete="stepper > 2"
                          :class="
                            stepper > 2
                              ? 'signup-step pl-0'
                              : 'signup-step hide-step-content pl-0'
                          "
                        >
                        </v-stepper-step>
                      </v-stepper-header>
                    </v-stepper>
                    <ValidationObserver
                      class="vuetify-form"
                      ref="obs"
                      v-slot="{ invalid, validated, passes }"
                    >
                      <v-form v-if="step === 0">
                        <v-row v-if="user">
                          <v-col cols="12">
                            <VTextInput
                              :placeholder="user.email"
                              readonly
                              label="Email Address *"
                            />
                          </v-col>
                          <v-col class="text-center" cols="12">
                            <v-btn color="gray" @click="nextStep">Next</v-btn>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12">
                            <ValidationProvider
                              rules="required|email"
                              v-slot="{ errors, valid }"
                            >
                              <v-text-field
                                v-model="firstStep.email"
                                placeholder="Your Email Address"
                                label="Email Address *"
                                :error-messages="errors"
                                :success="valid"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12">
                            <ValidationProvider
                              name="confirm"
                              :rules="passwordRules"
                              v-slot="{ errors, valid }"
                            >
                              <v-text-field
                                v-model.trim="firstStep.password"
                                :type="show1 ? 'text' : 'password'"
                                placeholder="Your Password"
                                label="New Password *"
                                name="confirm"
                                hint="Password must contain an upper case letter, a numeric character, and a special character"
                                :error-messages="errors"
                                :success="valid"
                              >
                                <template v-slot:append>
                                  <v-btn
                                    icon
                                    @click="show1 = !show1"
                                    tabindex="-1"
                                  >
                                    <v-icon v-if="show1">mdi-eye</v-icon>
                                    <v-icon v-if="!show1">mdi-eye-off</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12">
                            <ValidationProvider
                              rules="required|password:@confirm"
                              v-slot="{ errors, valid }"
                            >
                              <v-text-field
                                v-model="confirmPassword"
                                :error-messages="errors"
                                :success="valid"
                                :type="show2 ? 'text' : 'password'"
                                placeholder="Your Confirm Password"
                                label="Confirm Password *"
                              >
                                <template v-slot:append>
                                  <v-btn
                                    icon
                                    @click="show2 = !show2"
                                    tabindex="-1"
                                  >
                                    <v-icon v-if="show2">mdi-eye</v-icon>
                                    <v-icon v-if="!show2">mdi-eye-off</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col class="text-center mt-5" cols="12">
                            <v-btn
                              :disabled="invalid || !validated"
                              x-large
                              min-width="225"
                              min-height="50"
                              color="#FCAE00"
                              :dark="!invalid"
                              :loading="loading"
                              @click="passes(next)"
                              >Save & Next</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-form>
                    </ValidationObserver>
                    <ValidationObserver
                      class="vuetify-form"
                      ref="obs"
                      v-slot="{ invalid, passes }"
                    >
                      <v-form v-if="step === 1">
                        <v-row>
                          <v-col cols="12">
                            <VTextInput
                              v-model="secondStep.firstName"
                              :rules="{ required: true }"
                              placeholder="Your first name"
                              label="First Name *"
                            />
                          </v-col>

                          <v-col cols="12">
                            <VTextInput
                              v-model="secondStep.lastName"
                              :rules="{ required: true }"
                              placeholder="Your last name"
                              label="Last Name *"
                            />
                          </v-col>

                          <v-col cols="12">
                            <VTextArea
                              v-model="secondStep.bio"
                              placeholder="Your Short Bio"
                              label="Short Bio"
                              rows="3"
                            />
                          </v-col>
                          <v-col cols="12">
                            <ValidationProvider
                              :rules="{ required: { allowFalse: false } }"
                              v-slot="{ errors, valid }"
                            >
                              <v-checkbox
                                v-model="secondStep.terms"
                                required
                                :error-messages="errors"
                                :success="valid"
                              >
                                <template v-slot:label>
                                  <div
                                    class="accept-terms-condition terms-privacy-label"
                                  >
                                    I agree to the
                                    <a
                                      @click="
                                        redirectToNewTab('/terms&conditions')
                                      "
                                      class="text-link"
                                    >
                                      Terms & Conditions</a
                                    >
                                    and
                                    <a
                                      @click="
                                        redirectToNewTab('/privacy-policy')
                                      "
                                      class="text-link"
                                    >
                                      Privacy Policy</a
                                    >
                                  </div>
                                </template>
                              </v-checkbox>
                            </ValidationProvider>
                          </v-col>
                          <!-- <v-col
                            class="text-cente"
                            cols="12"
                            v-if="user.step === 1"
                          >
                            <v-btn v-if="user.step === 1" min-height="50" class="ma-2" color="gray" x-large @click="back"
                              >Previous</v-btn
                            >
                          </v-col> -->
                          <v-col class="text-center" cols="12">
                            <v-btn
                              v-if="user.step === 1"
                              min-height="50"
                              class="ma-2"
                              color="gray"
                              x-large
                              @click="back"
                              >Previous</v-btn
                            >
                            <v-btn
                              :disabled="invalid"
                              x-large
                              min-width="225"
                              min-height="50"
                              color="#FCAE00"
                              :loading="loading"
                              :dark="!invalid"
                              @click="passes(next)"
                              >Save & Next</v-btn
                            >
                          </v-col>
                          <v-col cols="12 mt-2" class="text-center">
                            <router-link
                              class="forgot-link"
                              :to="{ path: '/signup-link' }"
                              >Already started registration? Click
                              Here</router-link
                            >
                          </v-col>
                        </v-row>
                      </v-form>
                    </ValidationObserver>
                  </div>
                </div>
              </u-animate>
            </v-col>
          </v-row>
        </div>
      </div>
      <front-footer />
    </div>
    <!-- Cookie alert model -->
    <AcceptCookie />
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import FrontHeader from "../components/layouts/FrontHeader";
import FrontFooter from "../components/layouts/FrontFooter";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapGetters } from "vuex";
import { VTextInput, VTextArea } from "@/components/inputs";
import { AuthService } from "@/services";
import { PATIENT_ROLE } from "@/constants";
import NodeRSA from "node-rsa";

export default {
  name: "SignUp",
  components: {
    UAnimateContainer,
    UAnimate,
    FrontHeader,
    FrontFooter,
    ValidationObserver,
    VTextInput,
    //VCheckBox,
    VTextArea,
    ValidationProvider,
    AcceptCookie: () => import("@/components/AcceptCookie")
  },
  data() {
    return {
      step: 0,
      specialitiesList: [],
      role: [],
      loading: false,
      isLoading: false,
      firstStep: {
        email: "",
        password: null,
        step: 1
      },
      secondStep: {
        _id: null,
        firstName: "",
        lastName: "",
        bio: "",
        step: 2,
        terms: false
      },
      passwordRules: {
        required: true,
        min: 8,
        max: 32,
        passwordRegex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
      },
      show1: false,
      show2: false,
      stepper: 1,
      confirmPassword: ""
    };
  },
  watch: {
    step(newVal) {
      this.stepper = newVal + 1;
    }
  },
  computed: {
    ...mapGetters("user", {
      user: "user"
    })
  },
  async mounted() {
    const roleNames = await AuthService.getRoleName();
    this.role = roleNames.data.filter(role => {
      return role.name.toLowerCase() === PATIENT_ROLE.toLowerCase();
    });
    if (this.user) {
      this.step = this.user.step;
      this.secondStep._id = this.user._id;
      this.secondStep.firstName = this.user.firstName;
      this.secondStep.lastName = this.user.lastName;
      this.secondStep.bio = this.user.bio;
    }
  },
  methods: {
    async next() {
      if (this.step === 0) {
        const key = new NodeRSA(process.env.VUE_APP_PRIVATEKEY);
        this.loading = true;
        const firststep = {
          email: this.firstStep.email,
          password: key.encrypt(this.firstStep.password, "base64"),
          step: this.firstStep.step
        };
        const response = await AuthService.register(firststep);
        if (!response) {
          this.loading = false;
          return;
        }
        this.loading = false;
        this.step++;
        this.$store.dispatch("user/setUser", response.data.user);
        this.secondStep._id = this.user._id;
      } else {
        this.loading = true;
        this.isLoading = true;
        if (this.role.length) {
          this.secondStep.role = this.role[0]._id;
        }
        const response = await AuthService.register(this.secondStep);
        this.loading = false;
        this.isLoading = false;
        if (response) {
          this.step = 0;
          this.$store.dispatch(
            "user/setSnack",
            "Registered Successfully. You will receive an e-mail once your account has been created."
          );
          this.$store.dispatch("user/setType", "info");
          this.$store.dispatch("user/setUser", null);
          this.$router.push("/login");
        }
      }
    },
    termsConditions() {
      window.open("/terms&conditions", "_blank");
    },
    privacyPolicy() {
      window.open("/privacy-policy", "_blank");
    },
    back() {
      this.step--;
    },
    nextStep() {
      this.step++;
    },
    redirectToNewTab(url) {
      let route = this.$router.resolve({ path: url });
      window.open(route.href);
    }
  }
};
</script>
<style>
.v-application .success--text,
.v-application .primary--text {
  color: rgb(111 111 111) !important;
  caret-color: rgb(111 111 111) !important;
}
.terms-policy {
  margin: -12px 0 8px 0;
}
.accept-terms-condition {
  line-height: 20px;
}
.terms-privacy-label {
  font-size: 14px !important;
}
.signup-stepper {
  box-shadow: none !important;
}
.v-stepper__step--complete .v-stepper__step__step {
  background-color: #344452 !important;
}
.hide-step-content .v-stepper__step__step {
  content-visibility: hidden !important;
}
.signup-step .primary {
  background-color: #112b50 !important;
}
.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  border: 3px solid rgba(17, 43, 80, 0.6);
  background: #ffffff;
}
.v-stepper__step__step {
  margin-right: 0px !important;
}
.v-stepper .v-stepper__header .v-divider {
  border: 1px solid #c4c4c4;
}
</style>
